import { default as ReactSelect } from "react-select";

import { useReactSelectConfigProps } from "./reactSelectUtils";

// This is a wrapper component around react-select's Select component to ensure that
// accessibility and translation configurations are always used in every Select that are
// present in the app.
//
const Select = props => {
  const reactSelectConfigProps = useReactSelectConfigProps();

  return <ReactSelect {...reactSelectConfigProps} {...props} />;
};

export default Select;
